// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.external_api_form{padding:70px 40px;max-width:639px}`, "",{"version":3,"sources":["webpack://./converse/static/css/sass/_external_api.scss"],"names":[],"mappings":"AACA,mBACE,iBAAA,CACA,eAAA","sourcesContent":["\n.external_api_form{\n  padding:70px 40px;\n  max-width:639px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
